<form [formGroup]="formGroup">
    <mat-form-field>
        <input
            #searchTermRef
            type="text"
            matInput
            formControlName="query"
            [placeholder]="(isMobile$ | async) ? 'Search' : 'What are you looking for?'"
            (keydown.enter)="handleSearch($event)"
            (keyup)="keyup($event)"
            (focus)="onFocus()"
            (keydown.arrowup)="arrowUp($event)"
            (keydown.arrowdown)="arrowDown($event)"
            matTooltip="Search"
            [matTooltipShowDelay]="1000"
            [matTooltipHideDelay]="2000"
            [attr.data-analytics]="'search-bar'"
            [tabindex]="isOpen ? '' : '-1'" />
        <div class="suffix" [ngClass]="{ visible: isOpen && formGroup.controls.query.value != '' }">
            <!-- the normal `matSuffix` directive is insufficient for multiple icons with a divider -->
            <button
                class="clear"
                (click)="handleClear($event)"
                matTooltip="Clear search"
                [matTooltipShowDelay]="1000"
                [matTooltipHideDelay]="2000"
                [attr.data-analytics]="'clear-icon'"
                [tabindex]="isOpen ? '' : '-1'">
                <mat-icon [svgIcon]="'close'" aria-hidden></mat-icon>
            </button>
            <mat-divider [vertical]="true" aria-hidden></mat-divider>
            <button
                class="search"
                (click)="handleSearch($event)"
                matTooltip="Search"
                [matTooltipShowDelay]="1000"
                [matTooltipHideDelay]="2000"
                [attr.data-analytics]="'search-icon'"
                [tabindex]="isOpen ? '' : '-1'">
                <mat-icon [svgIcon]="'search'" aria-hidden></mat-icon>
            </button>
        </div>
    </mat-form-field>
</form>
<ng-container *ngIf="suggestions$ | async as suggestions">
    <div class="suggestions" *ngIf="suggestions.length > 1 && !showSearchSuggestions">
        @for (s of suggestions | slice: 0 : 5; track s.expression; let i = $index) {
            <button
                (click)="searchSuggestion(s)"
                tabindex="0"
                matTooltip="Click to search"
                [matTooltipShowDelay]="1000"
                [matTooltipHideDelay]="2000"
                [ngClass]="{ 'active-suggestion': (suggestionIndex$ | async) == i }"
                [innerHtml]="s | appHeaderSearchSuggestionMask">
            </button>
        }
    </div>
</ng-container>
<app-search-suggestions [isVisible]="showSearchSuggestions" [topPosition]="'60px'" (closePanel)="closeSuggestions()">
</app-search-suggestions>
